type DivProps = JSX.IntrinsicElements['div'];

interface ListProps extends DivProps {
    heading: string;
}

export const List = (props: ListProps) => {
    const { heading, ...divProps } = props;
    return <div aria-label={heading} role="list" {...divProps} />;
};
